import React from 'react'
import { ExpandMore } from '@mui/icons-material'
import { AccordionSummary, Grid } from '@mui/material'

import { withStyles } from '@mui/styles';

const MuiAccordionSummary = withStyles({
  root: {
    borderRightWidth: 0,
    borderLeftWidth: 0,
    margin: 0,
    marginTop: '16px',
  },
  expanded: {
    minHeight: '30px !important',
  },
  content: {
    margin: 0,
    '&$expanded': {
      margin: '0',
      padding: '0',
    },
  },
  expandIcon: {
    marginRight: 0,
    paddingTop: 0,
  },
})(AccordionSummary)

export const Summary: React.FC<{ open: number; index: number; term: any }> = ({
  open,
  index,
  term,
}) => {
  return (
    <MuiAccordionSummary 
      expandIcon={
        <ExpandMore
          className={open !== index ? 'close-icon' : 'open-icon'}
        />
      }
      aria-controls="panel1a-content"
      data-testid={`quota-${term.term}`}
      id={`quota-${term.term}`}
    >
      <Grid container>
        <Grid item className="bp-mb-12">
          <pichincha-typography color="black" variant="smallText">
            {term.title}
          </pichincha-typography>
          <pichincha-typography
            color="black"
            variant="smallText"
            class="bp-mt-4"
          >
            {term.subtitle}
          </pichincha-typography>
        </Grid>
      </Grid>
    </MuiAccordionSummary>
  )
}
